import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
  Link,
  
} from "@react-pdf/renderer";

import imgKkp from "../../assets/img/logo-kkp.png";
import srcArial from "../../assets/font/arial/arial.ttf";
import srcArialBold from "../../assets/font/arial/ARIBL0.ttf";

Font.register({ family: "Arial", src: srcArial });
Font.register({ family: "Arial-Bold", src: srcArialBold });
// Font.registerHyphenationCallback(word => [word]);


export const s = StyleSheet.create({
  page: {
    paddingTop: 30,
    paddingLeft:30,
    paddingRight:30,
    fontSize: 12,
    fontFamily: "Arial",
  },

  title: {
    textAlign: "center",
    fontFamily: "Arial-Bold",
    marginVertical: 6,
  },

  subtitle: {
    textAlign: "center",
    fontSize: 9,
    marginBottom: 10,
  },

  row: {
    flexDirection: "row",
    marginBottom: 4,
  },

  noCol: {
    width: 18,
  },

  label: {
    width: 140,
  },

  colon: {
    width: 6,
  },

  value: {
    flex: 1,
  },

  fieldRow: {
    flexDirection: "row",
    marginBottom: 2,
  },

  bold: {
    fontFamily: "Arial-Bold",
  },

  ttd: {
    marginTop: 60,
    fontSize: 12,
    alignItems: "center",
  },
  table: {
  display: "table",
  width: "100%",
  // borderWidth: 1,
  // borderStyle: "solid",
},

tableRow: {
  flexDirection: "row",
},

tableColNo: {
  width: "3.5%",
  borderRightWidth: 1,
  borderBottomWidth: 1,
  padding: 4,
},

tableColLabel: {
  width: "47%",
  borderRightWidth: 1,
  borderBottomWidth: 1,
  padding: 4,
},

tableColValue: {
  width: "50%",
  borderBottomWidth: 1,
  padding: 4,
},
tableColLabel2: {
  width: "60%",
  padding: 4,
},
tableColValue2: {
  width: "40%",
   padding: 4,
},

text: {
  fontSize: 12,
  lineHeight: 1.3,
},

footerRow: {
    marginTop: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
kknBox: {
    marginTop: 10,
    width: "40%",
    borderWidth: 1,
    padding: 8,
  },

  kknText: {
    fontSize: 11,
    textAlign: "center",
    fontFamily: "Arial-Bold",
    lineHeight: 1.2,
    textAlign: "justify", 
  },

  ttd: {
    width: "40%",
    alignItems: "left",
  },
  jabatanText: {
    marginTop: 5,
    fontSize: 12,
  },

  namaPejabat: {
    fontSize: 12,
    marginTop: 50,
      },

  fieldRow: {
  flexDirection: "row",
  alignItems: "flex-start",
},

});

const formatTanggal = (tanggal) => {
  if (!tanggal) return "";
  return new Date(tanggal).toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};



const LampProduk = ({ data, jadwal, produk }) => {
  const {   no_surat, tanggal_surat, pejabat_ttd } = data;
const jadwalUtama = jadwal[0] || {};


  return (
    <Page size="A4" style={s.page}>
        {/* <View style={[s.tableRow,{paddingBottom:4}]}>
            <View style={s.tableColLabel2}>
           
            </View>
                <View style={s.tableColValue2}>
                <Text style={{ fontSize: 9 }}>
                Lampiran 1 {"\n"}
                Nomor : 113/PMK.05/2012 {"\n"}
                Tanggal : 3 Juli 2012 
                </Text>
            </View>
        </View> */}
        

        <View style={s.table}>
         <View style={s.tableRow}>
              <View style={{ width :"100%", 
                                      }}>
                <View style={s.tableRow}>
                    <View style={{ width: "18%"}}>
                        <Text style={[s.text,{paddingTop:4,paddingLeft:4}]}>
                            </Text>
                    </View>
                    <View style={{ width : "30.5%",  }}>
                        <Text style={[s.text,{paddingTop:4}]}>
                             
                        </Text>
                    </View>
                    
                    <View style={{ width: "45%"}}>
                        <View style={s.tableRow}>
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:4,paddingLeft:4}]}>
                                    
                                </Text>
                            </View>
                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:4,paddingLeft:4}]}>
                                    Lampiran   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:4}]}>
                                    :  2
                                </Text>
                            </View>
                        </View>

                        <View style={s.tableRow}>               
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    
                                </Text>
                            </View>

                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Nomor   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    : {no_surat}
                                </Text>
                            </View>                    
                        </View>

                        <View style={s.tableRow}>               
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    
                                </Text>
                            </View>

                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Tanggal   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    : {formatTanggal(tanggal_surat)}
                                </Text>
                            </View>                    
                        </View>

                    </View> 
                </View>
                
            </View>
         </View>
       </View>     


            <View style={[s.table, { marginTop: 15 }]}>
                <View style={[s.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                    <View style={[s.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                        <Text style={[s.textBold, { fontSize: 11, textAlign: "center", paddingTop: 2, paddingBottom: 2 }]}>
                            No.
                        </Text>
                    </View>
                    <View style={[s.tableCol, { width: "35%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                        <Text style={[s.textBold, { fontSize: 11, textAlign: "center", paddingTop: 2, paddingBottom: 2 }]}>
                            Nama Unit Usaha
                        </Text>
                    </View>
                    <View style={[s.tableCol, { width: "30%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                        <Text style={[s.textBold, { fontSize: 11, textAlign: "center", paddingTop: 2, paddingBottom: 2 }]}>
                            Jenis Produk (Grade)
                        </Text>
                    </View>
                    <View style={[s.tableCol, { width: "30%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                        <Text style={[s.textBold, { fontSize: 11, textAlign: "center", paddingTop: 2, paddingBottom: 2 }]}>
                            Status
                        </Text>
                    </View>
                </View>


               {produk.map((item, index) => (                   
                    <View style={[s.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]} key={index}>
                    <View style={[s.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                        <Text style={{ fontSize: 11, textAlign: "center", paddingTop: 2 }}>{index + 1}</Text>
                    </View>
                    <View style={[s.tableCol, { width: "35%", paddingLeft: 4, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                        <Text style={{ fontSize: 11, paddingTop: 2 }}>
                        
                        {jadwalUtama.NM_UPI} 
                        </Text>
                    </View>
                    <View style={[s.tableCol, { width: "30%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                        <Text style={{ fontSize: 11, textAlign: "center", paddingTop: 2 }}>
                        {item.nama_produk} ({item.grade})
                        </Text>
                    </View>
                    <View style={[s.tableCol, { width: "30%", borderBottomWidth: 1 }]}>
                        <Text style={{ fontSize: 11, textAlign: "center", paddingTop: 2 }}>
                        {jadwalUtama.sts_pengajuan}
                        </Text>
                    </View>
                    </View>
                ))}
            </View>
            
<View style={[s.footerRow, { marginTop: 20 }]}>
        {/* KOTAK KKN */}
        <View style={s.kknBox}>
          <Text style={s.kknText}>
            Terima kasih untuk tidak memberikan sesuatu atau janji yang dapat mengakibatkan KKN, gratifikasi, dan benturan kepentingan
          </Text>
        </View>

        {/* TANDA TANGAN */}
        <View style={s.ttd}>
          

          <Text style={s.jabatanText}>
           Plt. Kepala Balai Pengendalian dan Pengawasan Mutu Hasil Kelautan dan Perikanan Jakarta, 
          </Text>

          <Text style={s.namaPejabat}>
            {pejabat_ttd}
          </Text>
        </View>
      </View>
    </Page>
  );
}

export default LampProduk;
